
import { Vue, Prop, Component } from 'nuxt-property-decorator';
import { RawHtml } from '../layout';
import Badge from '../Badge.vue';
import { TranslateResult } from '../../types/i18n';
import { FormFieldDto } from '../../services';

@Component({ components: { Badge, RawHtml } })
export default class FormFieldHeader extends Vue {
  @Prop({ required: true }) readonly field!: FormFieldDto;
  @Prop({ type: String, default: null }) readonly label!: TranslateResult | string | null;

  get overrideLabel() {
    return this.label || this.transl8(this.field.label);
  }

  get hasHeader() {
    return !!(this.overrideLabel || this.transl8(this.field.description) || this.field.isOrganizersOnly);
  }
}
